import { atom, selector } from "recoil"
import { Poll } from "../../../components/servicesPanel/polls/polls.interfaces"
import { PollsAction, Actions } from "./types"

export const pollsAtom = atom<Poll[]>({
  key: "pollsAtom",
  default: [],
  dangerouslyAllowMutability: true
})

export const pollsTamplateAtom = atom<Poll[]>({
  key: "pollsTamplateAtom",
  default: [],
  dangerouslyAllowMutability: true
})

export const pollsSelector = selector({
  key: "pollsSelector",
  get: ({ get }) => {
    return get(pollsAtom)
  },
  set: ({ set, get }, action) => {
    const { payload, type } = action as PollsAction

    if (type === "DOWNLOAD_POLLS") {
      set(pollsAtom, [...payload])
    }

    if (type === "CREATE_POLL") {
      set(pollsAtom, prev => {
        let haveThisPoll = false
        const data = prev.map(el => {
          if (el.id === payload.id) {
            haveThisPoll = true
            return payload
          }
          return el
        })

        return haveThisPoll ? data : prev.concat([payload])
      })
    }

    if (type === "UPDATE") {
      set(pollsAtom, prev => {
        const poll = prev.map(el => {
          if (el.id === payload.id) {
            el.totalResponses = payload.totalResponses
            el.choices = payload.choices
            el.isVisible = payload.isVisible
          }
          return { ...el }
        })

        return [...poll]
      })
    }

    if (type === "TOGGLE_POLL_MOBILE") {
      set(pollsAtom, prev => {
        const poll = prev.map(el => {
          if (el.id === payload.id) {
            el.isVisibleMobile = payload.visibleMobile
          }
          return el
        })

        return [...poll]
      })
    }

    if (type === "DELETE_POLL") {
      set(pollsAtom, prev => prev.filter(el => el.id !== payload.delete))
    }

    if(type === "RESET") {
      set(pollsAtom, [])
    }
  }
})

export const pollsTamplateSelector = selector({
  key: "pollsTamplateSelector",
  get: ({ get }) => {
    return get(pollsTamplateAtom)
  },
  set: ({ set, get }, action) => {
    const { payload, type } = action as PollsAction

    if (type === "CREATE_TAMPLATE_POLL") {
      set(pollsTamplateAtom, [...get(pollsTamplateAtom), payload])
    }

    if (type === "DELETE_TAMPLATE_POLL") {
      set(pollsTamplateAtom, prev => prev.filter(el => el.id !== payload.id))
    }
  }
})

interface pollsCallbackSelectorProps {
  handleReturnData?: () => Promise<Poll[]>
}

export const pollsCallbackSelector = selector<pollsCallbackSelectorProps>({
  key: "pollsCallbackSelector",
  get: ({ getCallback }) => {
    const handleReturnData = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(pollsAtom)

      return data
    })
    return { handleReturnData }
  }
})

export const middlewarePolls =
  ({ type, payload }) =>
  (oldValue: Poll[]) => {
    if (type === Actions.DOWNLOAD_POLLS) {
      return [...payload]
    }

    if (type === Actions.CREATE_POLL) {
      let haveThisPoll = false
      const data = oldValue.map(el => {
        if (el.id === payload.id) {
          haveThisPoll = true
          return payload
        }
        return el
      })

      return haveThisPoll ? data : oldValue.concat([payload])
    }

    if (type === Actions.UPDATE) {
      const poll = oldValue.map(el => {
        if (el.id === payload.id) {
          el.totalResponses = payload.totalResponses
          el.choices = payload.choices
          el.isVisible = payload.isVisible
        }
        return el
      })

      return [...poll]
    }

    if (type === Actions.CREATE_POLL) {
      const poll = oldValue.map(el => {
        if (el.id === payload.id) {
          el.isVisible = payload.visible
        }
        return el
      })

      return [...poll]
    }

    if (type === Actions.DELETE_POLL) {
      return oldValue.filter(el => el.id !== payload.delete)
    }
  }
